import { render, staticRenderFns } from "./CustomerDetail2.vue?vue&type=template&id=4a85f700&scoped=true"
import script from "./CustomerDetail2.vue?vue&type=script&lang=js"
export * from "./CustomerDetail2.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail2.vue?vue&type=style&index=0&id=4a85f700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a85f700",
  null
  
)

export default component.exports